// extracted by mini-css-extract-plugin
export default {"verticalCarousel":"sBe_eqzZVz","arrow":"GFX9Xkt2aQ","carouselContainer":"xN72mN5Nus","carousel":"LpPIH1jZ9R","arrowDisabled":"VLFQ9wuyKB"};